import React from 'react';

const PrincipalsContext = React.createContext(null);

export default PrincipalsContext;

